export default "__VITE_ASSET__D8bpRR5k__"